module.exports = "/static/assets/43c143c16bc7fc957f1f8687c5830025.png";